import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landingpage.css';

function LandingPage() {
    return (
        <div className='container'>
            <div className='main landingpage'>
                <div>
                    <p className="mt-5 heading">Welcome!</p>
                    <h1>iSelfie Test</h1>
                    <p>For instant COVID-19 Screening</p>
                </div>
                <div className="btn-signin">
                    <Link to='/login'><button>Log In</button></Link>
                </div>
                <div className="btn-signup mt-4">
                    <Link to='/signup'><button>Sign Up</button></Link>
                </div>
            </div>
        </div>
    )
}

export default LandingPage;
